export default __webpack_public_path__ + "static/media/add_blood_req.366ce838.png";